const preloadImage = (imgSrc='')=>{
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = ()=>{resolve()};
        img.onerror = ()=>{reject()};
        img.src = imgSrc;
    });
};

export default (images=[])=>{
    return new Promise((resolve, reject) => {
        if(images.length){
            const preloadPromises = [];
            images.forEach((img)=>{
                preloadPromises.push(preloadImage(img));
            });
            Promise.all(preloadPromises).finally(() => {
                resolve();
            });
        }else
            resolve();
    });
};
